import { render, staticRenderFns } from "./DetailedTK.vue?vue&type=template&id=23109586"
import script from "./DetailedTK.vue?vue&type=script&lang=js"
export * from "./DetailedTK.vue?vue&type=script&lang=js"
import style0 from "./DetailedTK.vue?vue&type=style&index=0&id=23109586&prod&lang=css"
import style1 from "./DetailedTK.vue?vue&type=style&index=1&id=23109586&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports